import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Box,
  Divider,
} from '@material-ui/core'
import { Snackbars as Snackbar } from 'components'
import CloseIcon from '@material-ui/icons/Close'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import { InnrHead } from 'containers'
import AddNewPlayer from 'containers/AddNewPlayer'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { compose } from 'redux'
import { teams as teamsModule } from 'redux/modules'
import FilterNoneOutlinedIcon from '@material-ui/icons/FilterNoneOutlined'
import { track } from 'utils/segmentTracking'
import useStyles from '../../UserManagement/styles'
import { team as teamEvent } from 'constants/trackeventsname'

const AddOrganizationTeamPlayersDialog = ({
  open,
  onClose,
  fetchInviteUrl,
  team,
  handleAddClick,
  onSearchValue,
  searchOpen,
  setSearchOpen,
}) => {
  const classes = useStyles()
  const [deepLink, setDeepLink] = useState('Loading...')
  const [snackbar, setSnackbar] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (open) {
      setSearchValue('')
      setSearchOpen(false)
    }
  }, [open])

  useEffect(() => {
    fetchInviteUrl(team.uuid).then(({ response: { data } }) => {
      setDeepLink(data.url)
    })
  }, [])

  const handleLinkClick = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(deepLink)

    setSnackbar({
      message: <Translate id="team-invite.link-copied" />,
      success: true,
    })

    track(teamEvent.team_players_invite_link_copy, {
      team_id: +team.id,
      category: teamEvent.team,
    })
  }

  return (
    open && (
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        PaperProps={{ elevation: 0 }}
      >
        <InnrHead title={<Translate id="team-invite.add-players" />}>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </InnrHead>
        <DialogContent style={{ paddingBottom: '1.5rem' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" component="p">
                <strong>
                  <Translate id="team.members.search-for-player" />
                </strong>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <AddNewPlayer
                onClose={onClose}
                handleAddClick={handleAddClick}
                onSearchValue={onSearchValue}
                searchOpen={searchOpen}
                setSearchValue={setSearchValue}
                searchValue={searchValue}
                setSearchOpen={setSearchOpen}
              />
            </Grid>
          </Grid>
          <Box
            display="flex"
            alignItems="center"
            style={{ width: '100%', margin: '2rem 0 1rem' }}
          >
            <Divider style={{ flexGrow: 1 }} />
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ margin: '0 8px' }}
            >
              <Translate id="team.members.or" />
            </Typography>
            <Divider style={{ flexGrow: 1 }} />
          </Box>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              component="h4"
              className={classes.invitationLink}
            >
              <Translate id="team-invite.send-link-title" />
            </Typography>
            <Typography variant="h6" component="h6" paragraph>
              <Translate id="team-invite.send-link-subtitle" />{' '}
              <Typography variant="body1" component="span">
                <strong> &quot;{team.name}&quot;</strong>
              </Typography>
            </Typography>
            <Box
              width="100%"
              mb={1}
              display="flex"
              alignItems="center"
              onClick={handleLinkClick}
              role="button"
            >
              <a href={deepLink} className={classes.deepLink}>
                {deepLink}
                <FilterNoneOutlinedIcon
                  fontSize="inherit"
                  className={classes.copyIcon}
                />
              </a>
            </Box>
          </Grid>
          {snackbar && <Snackbar {...snackbar} />}
        </DialogContent>
      </Dialog>
    )
  )
}

AddOrganizationTeamPlayersDialog.propTypes = {
  team: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    organization_uuid: PropTypes.string.isRequired,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fetchInviteUrl: PropTypes.func.isRequired,
  handleAddClick: PropTypes.func.isRequired,
  onSearchValue: PropTypes.func.isRequired,
  searchOpen: PropTypes.bool.isRequired,
  setSearchOpen: PropTypes.func.isRequired,
}

export default compose(
  withRouter,
  connect(
    ({ team }) => ({
      team,
    }),
    {
      fetchInviteUrl: teamsModule.fetchInviteUrl,
    }
  )
)(AddOrganizationTeamPlayersDialog)
